"use client";

import { MessageProvider } from "../shared/message-providers";
import dynamic from "next/dynamic";

import "@costar/theme-ui/resources/styles/index.css";

import {
  UserPreferencesContext,
  UserPreferences,
} from "@costar-suite/preferences-context";

const ContactSearchX = dynamic(() => import("./ContactsSearchX"));

export default function ContactsDirectory({
  isAuthenticated,
  userPreferences,
}: {
  isAuthenticated?: boolean;
  userPreferences: UserPreferences;
}) {
  return (
    <MessageProvider>
      <UserPreferencesContext.Provider
        value={userPreferences satisfies UserPreferences}
      >
        <ContactSearchX
          isAuthenticated={isAuthenticated}
          userPreferences={userPreferences}
        />
      </UserPreferencesContext.Provider>
    </MessageProvider>
  );
}
